import React, { ReactNode, useEffect, useLayoutEffect, useRef } from 'react';
import '../Timeline/TimelineComponent.scss';
import './SalesTimeline.scss';

import 'PDF/components/Timeline/TimelineComponent.scss';
import 'PDF/components/SalesFunnel/SalesTimeline.scss';
import FifthStepIcon from 'PDF/assets/icons/FifthStepIcon.svg';
import FirstStepIcon from 'PDF/assets/icons/FirstStepIcon.svg';
import FourthStepIcon from 'PDF/assets/icons/FourthStepIcon.svg';
import SecondStepIcon from 'PDF/assets/icons/SecondStepIcon.svg';
import ThirdStepIcon from 'PDF/assets/icons/ThirdStepIcon.svg';
import { ReactComponent as SalesShareBackground} from 'PDF/assets/images/SalesShareBackground.svg';

interface ITimelineProps {
  className?: string;
  tip?: boolean;
  children: ReactNode;
}

const orderedSalesTimelineImages = [FirstStepIcon, SecondStepIcon, ThirdStepIcon, FourthStepIcon, FifthStepIcon];

export const SalesTimeline: React.FC<ITimelineProps> = ({ className, tip = true, children }) => {
  const tipClassName = tip ? 'with-tip' : '';
  const fullClassName = `container sales timeline-wrapper ${tipClassName} ${className || ''}`;
  const numBookmarks = React.Children.count(children);
  const timelineRef = useRef<HTMLDivElement>(null);
  const styleRef = useRef<HTMLStyleElement | null>(null);

  useLayoutEffect(() => {

     if (!styleRef.current) {
      styleRef.current = document.createElement('style');
      styleRef.current.setAttribute('data-timeline-styles', '');
    }

       const cssRules = Array.from({ length: numBookmarks }, (_, i) => 
      `.timeline-item:nth-child(${i + 1}) { grid-row: ${i + 1}; }`
    ).join('\n');

     styleRef.current.textContent = cssRules;

     if (!styleRef.current.parentNode) {
      document.head.appendChild(styleRef.current);
    }

    return () => {
      if (styleRef.current?.parentNode) {
        styleRef.current.parentNode.removeChild(styleRef.current);
      }
      styleRef.current = null;
    };
  }, [numBookmarks]);

  useEffect(() => {
    const dotmarks = timelineRef.current?.querySelectorAll('.timeline-dotmark');
    if (dotmarks) {
      const lastDotmark = dotmarks[dotmarks.length - 1];
      lastDotmark?.querySelector('.timeline-dot')?.classList.add('no-after');
    }
  }, [children]);

  return (
    <div className={fullClassName} ref={timelineRef}>
      <div className="sales-background-image">
        <SalesShareBackground />
      </div>
      <div className="timeline-connector" />
      <ul className="timeline">
        {children}
        {Array(numBookmarks)
          .fill(null)
          .map((_, i) => (
            <span key={i} className="timeline-dotmark">
            <div className={`timeline-dot ${i === numBookmarks - 1 ? (i + 1) % 2 == 1 ? 'last-timeline-dot-odd' : 'last-timeline-dot-even' : ''}`}>
                <div className='border'>
                  <img src={orderedSalesTimelineImages[i]} />
                </div>
              </div>
            </span>
          ))}
      </ul>
    </div>
  );
};
